import { z } from 'zod';

export const matchSchema = z.object({
  name_en: z.string().min(1, 'Name is required'),
  name_fr: z.string().nullable().optional(),
  name_es: z.string().nullable().optional(),
  name_lt: z.string().nullable().optional(),
  name_ru: z.string().nullable().optional(),
  name_de: z.string().nullable().optional(),
  name_sp: z.string().nullable().optional(),
  name_ca: z.string().nullable().optional(),
  start_utc: z.string().min(1, 'Start UTC is required'),
  match_feed_id: z.string().min(1, 'Match feed ID is required'),
  teams: z
    .array(z.object({ team_id: z.number() }))
    .min(1, 'Teams are required'),
  competition_id: z.number().min(1, 'Competition ID is required'),
});

export type MatchSchema = z.infer<typeof matchSchema>;
